import React from 'react';

import {Card, Stack, Typography} from '@mui/material';
import playButton from 'presentation/assets/images/play_button.svg';
import thumbTele from 'presentation/assets/images/thumb_tele.png';
import {translations} from 'presentation/translations-new';
import {StyledBox, StyledCardActionArea, StyledCardMedia, StyledPlayer} from './styles';
import {TelehealthVideoCardProps} from './types';

const {confirmationPage} = translations['pt-br'].privateFlow.bookingFlow;

export function TelehealthVideoCard({tutorialLink}: TelehealthVideoCardProps) {
	const handleOpenTutorial = () => {
		window.open(tutorialLink, '_blank', 'noopener,noreferrer');
	};

	return (
		<Card variant="outlined" sx={{borderRadius: '12px'}}>
			<StyledCardActionArea onClick={handleOpenTutorial}>
				<StyledBox>
					<StyledCardMedia component="img" image={thumbTele} />

					<StyledPlayer component="img" src={playButton} alt="play" />
				</StyledBox>
				<Stack gap={0.5} p={2} flex={1}>
					<Typography variant="body2" fontWeight={600}>
						{confirmationPage.portalTeleconsulta}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{confirmationPage.videoDescription}
					</Typography>
				</Stack>
			</StyledCardActionArea>
		</Card>
	);
}
